import React from 'react';

import { createPortal } from 'react-dom';

import styled from 'styled-components';

import { Box, Popover } from 'components';

import { ModalCloseButton } from './ModalCloseButton';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 1299;
`;

export type Props = {
  height?: string;
  width?: string;
  onClose: () => void;
  children?: React.ReactNode;
};

export const ModalBox: React.FC<Props> = ({
  height,
  width,
  onClose,
  children,
}) => {
  return (
    <>
      {createPortal(<Overlay onClick={onClose} />, document.body)}
      <Popover
        anchorEl={document.body}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        open={true}
        slotProps={{
          paper: {
            sx: {
              overflow: 'visible',
              maxWidth: '100%',
              width: width || 'auto',
              margin: 0,
              padding: 0,
              boxSizing: 'border-box',
              borderRadius: '12px',
              border: '1px solid #E5E7EB',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
            },
          },
        }}
      >
        <Box position="relative" padding="2rem">
          <ModalCloseButton onClose={onClose} />
          <Box height={height} overflow={height ? 'auto' : 'visible'}>
            {children}
          </Box>
        </Box>
      </Popover>
    </>
  );
};
